export default __webpack_public_path__ + "static/media/closet3-768w.20d06df5.png";